import api from "../../api/api";
import API_URL from "../../api/url";
import axios from "axios";

const RoleRequest = {
  // Fetch a filtered list of roles based on specific parameters
  roleFilteredList: (values) =>
    api.get(`${API_URL.BASEURL}${API_URL.getRoleFilterSet}`, {
      params: {
        roleName: values?.roleName,
      },
    }),

  // Fetch the list of all roles
  roleList: () => api.get(`${API_URL.BASEURL}${API_URL.getRoleList}`),
  // deleteCategory: (id) => api.post(`${API_URL.BASEURL}${API_URL.deleteCategory}`, id),
  updateRole: (values) =>
    api.post(`${API_URL.BASEURL}${API_URL.updateRole}`, values),
  roleDetail: (id) =>
    api.get(`${API_URL.BASEURL}${API_URL.roleDetail}?roleId=${id}`),
  createRole: (values) =>
    api.post(`${API_URL.BASEURL}${API_URL.createRole}`, values),
};

export default RoleRequest;
